module.exports = __webpack_public_path__ + "static/media/workable-hero-art.4ba7675e.svg";